const mapLayers = {
	temperature: "Temperatur",
	salinity: "Saltholdighet",
	currents: "Strømmer"
};

export default mapLayers;
export { mapLayers };
